import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogOut, ClipboardCheck } from 'lucide-react';
import { useSettings } from '@/contexts/SettingsContext';
import firstName from '@/utils/firstName';
import HorariosPage from './HorariosPage';

const SubdirectorDashboard = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const { settings } = useSettings();

  const handleLogout = () => { onLogout(); navigate('/login'); };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="subdirector-dashboard">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ClipboardCheck className="w-6 h-6 text-indigo-600" />
            <div>
              <h1 className="text-base font-semibold text-slate-900">{settings?.app_name || 'MATE'} · Subdirección</h1>
              <p className="text-xs text-slate-500">Cumplimiento de horarios</p>
            </div>
          </div>
          <Button variant="outline" size="sm" onClick={handleLogout} data-testid="subdirector-logout">
            <LogOut className="w-4 h-4 mr-2" /> Salir
          </Button>
        </div>
      </header>
      <main className="max-w-5xl mx-auto p-4">
        {firstName(user?.name) && (
          <p className="text-sm text-slate-500 mb-1" data-testid="welcome-greeting">
            Bienvenido(a), <span className="font-semibold text-slate-700">{firstName(user?.name)}</span>
          </p>
        )}
        <h2 className="text-lg font-semibold text-slate-800 mb-1">Horarios por grupo</h2>
        <p className="text-sm text-slate-500 mb-4">Consulta el cumplimiento de los profesores. Vista de solo lectura; elige un grupo y una semana.</p>
        <HorariosPage user={user} embedded />
      </main>
    </div>
  );
};

export default SubdirectorDashboard;
